<template>
    <!-- <div class="p-card p-component" :style="{maxWidth: cardWidth}"> -->
    <component is="router-link" class="p-card p-component card p-border-card" :id="id" :to="to" style="text-decoration: none !important; box-shadow: 0px 3px 6px #0000001A !important;">
        <div class="p-card-header" v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div class="p-card-body">
            <div class="p-card-title" v-if="$slots.title"><slot name="title"></slot></div>
            <div class="p-card-subtitle" v-if="$slots.subtitle"><slot name="subtitle"></slot></div>
            <div class="p-card-content" style="padding-top: 0px !important; padding-bottom: 0px;">
                <slot name="content"></slot>
            </div>
        </div>
    </component>
</template>

<script>
export default {
    name: 'CardCatalog',
    props: {
        cardWidth: {
            type: String,
            default: '320px' // px, rem, em, etc.
        },
        id: {
            type: String
        },
        to: {
            type: String
        }
    }
}
</script>

<style>
.p-card-header img {
    width: 100%;
}
.p-card {
    background: var(--iu-tertiary) 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 6px var(--iu-box-shadow-1) !important;
    background: #F6F6F6 0% 0% no-repeat padding-box !important;
}
.p-border-card {
    border-radius: 18px !important;
}
.p-card-title {
    font-family: var(--font-acumin-pro-light) !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    letter-spacing: 0px;
    color: #0A3C45;
}
.p-card-subtitle {
    font-family: var(--font-acumin-pro-light) !important;
    font-size: 18px !important;
}
.p-card-body  {
    padding: 24px 16px 24px 16px !important;
    background: #F6F6F6 0% 0% no-repeat padding-box !important;
    border-radius: 10px !important;
}
p {
    margin: 0px !important;
    font-family: var(--font-acumin-pro-light) !important;
    font-size: 15px !important;
    letter-spacing: 0px;
    color: var(--iu-textcolor);
}
.p-card-content {
    p {
        line-height: 20px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
    }
}
@media screen and (min-width: 60em) {
    .card {
        flex: 0 1 calc(25% - 1em) !important;
    }
}
</style>
